import Vue from 'vue'
import lamp from './lampOperation.vue'

const PopupBox = Vue.extend(lamp);

lamp.install = function (data) {
  let instance = new PopupBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
};

export default lamp



// WEBPACK FOOTER //
// ./src/components/popup/lampOperation.js